module.exports = require("react-measure");